import { Box, Container, Grid, Typography } from "@mui/material"
import { useApiGet, useApiPost } from "auth/useApi2"
import { GlobalLoaderContext } from "components/GlobalLoadingProvider"
import { PageTabs } from "components/navigation/PageTabs/PageTabs"
import { apiEndpoints } from "generated/apiEndpoints"
import { allRoutes } from "generated/routes"
import React, { useEffect } from "react"
import { useHistory } from "react-router-dom"
import { EquipmentForm } from "../../components/EquipmentForm"
import { useTranslation } from "react-i18next"

const EquipmentAdd = () => {
  const { t } = useTranslation()
  const [addEquipmentResult, addEquipment] = useApiPost()
  const routerHistory = useHistory()
  const loadingContext = React.useContext(GlobalLoaderContext)

  const [companyResult, getCompany] = useApiGet()
  const [storagesResult, getStorages] = useApiGet()
  const [devicesResult, getDevices] = useApiGet()
  const [equipmentStatuses, getEquipmentStatuses] = useApiGet()
  const [externalDeviceResult, getExternalDevice] = useApiGet()

  const toCreatePayload = (values) => {
    return { ...values, ioPriority: true, positionPriority: true }
  }

  const handleSubmit = (objectToSave) => {
    addEquipment(apiEndpoints.systemadmindeviceregistry.addequipment, toCreatePayload(objectToSave))
  }

  useEffect(() => {
    getCompany(apiEndpoints.systemadmindeviceregistry.listcompanies)
    getStorages(apiEndpoints.systemadmindeviceregistry.liststorages)
    getDevices(apiEndpoints.systemadmindeviceregistry.listdevices)
    getEquipmentStatuses(apiEndpoints.systemadmindeviceregistry.getequipmentstatuses)
    getExternalDevice(apiEndpoints.systemadmindeviceregistry.listexternaldeviceregistrydevicetypes)
  }, [getCompany, getDevices, getStorages, getEquipmentStatuses, getExternalDevice])

  useEffect(() => {
    loadingContext.setLoading(() => companyResult.status === 1)
  })
  useEffect(() => {
    loadingContext.setLoading(() => storagesResult.status === 1)
  })
  useEffect(() => {
    loadingContext.setLoading(() => devicesResult.status === 1)
  })
  useEffect(() => {
    loadingContext.setLoading(() => equipmentStatuses.status === 1)
  })
  useEffect(() => {
    loadingContext.setLoading(() => externalDeviceResult.status === 1)
  })

  useEffect(() => {
    if (addEquipmentResult.status === 2) routerHistory.push(allRoutes.SystemadminDevicesEquipment())
  }, [addEquipmentResult.status, routerHistory])

  const feedback = {
    errorTitle: t("global.equipment_could_not_be_created", "Equipment could not be created")
  }

  return (
    <div>
      <PageTabs
        routeBack
        tabs={[
          {
            path: allRoutes.SystemadminDevicesEquipment(),
            title: t("global.back", "Back")
          }
        ]}
      />
      <Container>
        <Box marginY={3}>
          <Grid container direction="row" justifyContent="flex-start" alignItems="center">
            <Typography variant="h2">{t("global.add_equipment", "Add Equipment")}</Typography>
          </Grid>
        </Box>
        {companyResult.status === 2 &&
          devicesResult.status === 2 &&
          equipmentStatuses.status === 2 &&
          storagesResult.status === 2 &&
          externalDeviceResult.status === 2 && (
            <EquipmentForm
              companyResult={companyResult}
              storagesResult={storagesResult}
              devicesResult={devicesResult}
              externalDeviceResult={externalDeviceResult}
              equipmentStatuses={equipmentStatuses}
              onSubmit={handleSubmit}
              feedback={feedback}
              result={addEquipmentResult}
            />
          )}
      </Container>
    </div>
  )
}

export default EquipmentAdd
